import * as api from '../util/apis';
import { ENV } from '../constants/Constants';



export const getFeedbackByUser = async (): Promise<any> => {
	try {
		const resp: any = await api.getapiresponses(ENV.dev.feedback);
		return Promise.resolve(resp.data.data);
	} catch (error) {
		return Promise.reject(error);
	}
};

export const createFeedback = async (requestData:any) => {
	const resp: any = await api.postapiresponses(ENV.dev.feedback, requestData)
	return resp
  }
  
export const updateFeedback = async (feedbackId: any, requestData: any) => {
	const resp = await api.putapiresponses(
		ENV.dev.feedback + '/' + feedbackId,
		requestData,
	);
	return resp;
};
